import { Injectable } from '@angular/core';
import { AppService } from '@shared/services/core/app.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { APIResponse, ChangePasswordPayload, ChangePasswordResponse } from '@shared/models/auth.interface';
@Injectable({
  providedIn: 'root'
})
export class ChangePasswordService {
  private _clientPortalAPIDomain!: string;
   private _licenseAPIDomain!: string;
  constructor(  private _appService: AppService,private http: HttpClient) {
    this._clientPortalAPIDomain = this._appService.getAppConfigs()["CLIENTPORTAL"].BaseUrl;
    this._licenseAPIDomain = this._appService.getAppConfigs()["LICENSE"].BaseUrl;
  }


  changePassword(requestBody: ChangePasswordPayload) {
    const changePasswordAPI = this._appService.getAppConfigs()["CLIENTPORTAL"].Versions.V1["CHANGEPASSWORD"]["changePassword"].PATH;
    const url = this._clientPortalAPIDomain + changePasswordAPI;
    const ApiHeaders = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.post<APIResponse<ChangePasswordResponse>>(url, requestBody, { headers: ApiHeaders });
  }
  checkToken(token: any,datapost:any) {
    const changePasswordAPI = this._appService.getAppConfigs()["LICENSE"].Versions.V1["TOKENCHECK"]["tokencheck"].PATH;
    const url = this._licenseAPIDomain  + changePasswordAPI;
    
    const authHeaders = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    });
    
   return this.http.post<APIResponse<ChangePasswordResponse>>(url,datapost,  { headers: authHeaders });
  }
  resetPassword(requestBody: any) {
    const changePasswordAPI = this._appService.getAppConfigs()["CLIENTPORTAL"].Versions.V1["FORGOTPASSWORD"]["resetPassword"].PATH;
    const url = this._clientPortalAPIDomain + changePasswordAPI;
    const ApiHeaders = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.post<APIResponse<ChangePasswordResponse>>(url, requestBody, { headers: ApiHeaders });
  }
  
}
